const getConfig = () => {
  return JSON.parse(document.getElementById('js-config').innerHTML);
};

export const hasToken = () => {
  return getConfig().google.accessToken.length > 0;
};

export const initializeGapiClient = (callback) => {
  gapi.load('client:picker', () => {
    gapi.client.init({
      apiKey: getConfig().google.apiKey,
      discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'],
    });

    gapi.client.setToken({ access_token: getConfig().google.accessToken });

    callback();
  });
};

const googleScripts = [];

export let googleScriptsLoaded = false;

export const initGoogleScript = (script) => {
  googleScripts.push(script);

  if (googleScripts.includes('api') && googleScripts.includes('client')) {
    googleScriptsLoaded = true;

    const event = new Event('google-api-loaded');
    window.dispatchEvent(event);
  }
};

export const showGoogleDrivePicker = (pickerCallback) => {
  const docsView = new google.picker.DocsView()
    .setIncludeFolders(true)
    .setMimeTypes('application/vnd.google-apps.folder')
    .setSelectFolderEnabled(true);

  const picker = new google.picker.PickerBuilder()
    .addView(docsView)
    .setOAuthToken(gapi.client.getToken().access_token)
    .setDeveloperKey(getConfig().google.apiKey)
    .setCallback(pickerCallback)
    .setAppId(getConfig().google.clientId)
    .build();

  picker.setVisible(true);
};
